module.exports = __webpack_public_path__ + "img/1.63ac9798.svg";